module.exports = __webpack_public_path__ + "static/@1x-oculoplastic-xs-b2ed9163207aa3a6dffe1fd6d1b40ca6.jpg";